var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.type ? 'excel-button-container active' : 'excel-button-container',on:{"click":_vm.changeButton}},[_c('span',[_vm._v("空值置0")]),_c('div',{staticClass:"swich-container"},[_c('span',{staticClass:"swich-button"}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.type ? '开' : '关'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }